import { render } from "./ProductiveTask.vue?vue&type=template&id=173926da&scoped=true"
import script from "./ProductiveTask.vue?vue&type=script&lang=js"
export * from "./ProductiveTask.vue?vue&type=script&lang=js"

import "./ProductiveTask.vue?vue&type=style&index=0&id=173926da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173926da"]])

export default __exports__